export default "__VITE_ASSET__x7e2Z3ms__"